export const players = [
    {
        name: "Santiaguito",
        preview: "/game_images/characters/player_boy.svg",
        chatImage: "",
        inventory: [],
        sprite: {
            spriteUrl: "/images/game/sprites/player_boy.png",
            fps: 6,
            frameSize: {
                width: 455.5,
                height: 594
            },
            animations: {
                walk_se: { position: 0, frames: 4 },
                walk_ne: { position: 1, frames: 4 },
                walk_sw: { position: 2, frames: 4 },
                walk_nw: { position: 3, frames: 4 }
            }
        }
    },
    {
        name: "Carmencita",
        preview: "/game_images/characters/player_girl.svg",
        chatImage: "",
        inventory: [],
        sprite: {
            spriteUrl: "/images/game/sprites/player_girl.png",
            fps: 6,
            frameSize: {
                width: 455.5,
                height: 594
            },
            animations: {
                walk_se: { position: 0, frames: 4 },
                walk_ne: { position: 1, frames: 4 },
                walk_sw: { position: 2, frames: 4 },
                walk_nw: { position: 3, frames: 4 }
            }
        }
    }
];
